import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { PillButton } from "mds/components/PillButton";
import { Tooltip } from "mds/components/Tooltip";
import { LockLockedIcon } from "mds/icons";

export const PageLockedButton: FC = () => {
  return (
    <Tooltip text={t("lock_status.student_lock_warning")}>
      <PillButton kind="dark-gray" size="m" disabled>
        <IconText iconStart={<LockLockedIcon />} text={t("lock_status.page_locked")} />
      </PillButton>
    </Tooltip>
  );
};
